export default __webpack_public_path__ + "static/media/insightdata_analyse.1d4446a3.svg";